import React, { ChangeEvent, ReactElement } from 'react';

import { Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { FilterDropdownProps } from 'antd/lib/table/interface';

type Props = {
  dataIndex: string;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSearch: (selectedKeys: React.Key[], dataIndex: string) => void;
  className?: string;
} & FilterDropdownProps;

export const TableFilterDropdown = (props: Props): ReactElement => {
  const {
    dataIndex,
    onSearch,
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
    className,
  } = props;

  const handleSearch = () => {
    confirm();
    onSearch(selectedKeys, dataIndex);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedKeys(e.target.value ? [e.target.value] : []);
  };

  return (
    <div className={className}>
      <Input
        placeholder="Search"
        value={selectedKeys[0]}
        onChange={handleChange}
        onPressEnter={handleSearch}
      />
      <Space>
        <Button
          type="primary"
          size="small"
          onClick={handleSearch}
          icon={<SearchOutlined />}
        >
          Filter
        </Button>
        <Button size="small" onClick={clearFilters}>
          Reset
        </Button>
      </Space>
    </div>
  );
};
